import Reveal from "./Reveal";
import { ArrowUpRight } from "lucide-react";

const IMG_B =
  "https://customer-assets-lqy194kg.emergentagent.net/job_design-refresh-642/artifacts/1a7eavku_Image%20B.jpg";
const IMG_C =
  "https://customer-assets-lqy194kg.emergentagent.net/job_design-refresh-642/artifacts/ew90yq31_Image%20C.jpg";
const IMG_D =
  "https://customer-assets-lqy194kg.emergentagent.net/job_design-refresh-642/artifacts/fo69joyd_Image%20D.jpg";

const chapters = [
  {
    num: "01",
    title: "L'opportunité",
    text: "Le marché de l'énergie B2C — notre premier segment de chiffre d'affaires — est en pleine recomposition : les ménages cherchent des experts de proximité capables de sécuriser leurs contrats. Le B2B vient naturellement ensuite. Cette fenêtre ne se reproduira pas.",
    img: IMG_B,
    alt: "L'équipe d'une agence Alternativ célèbre une signature",
  },
  {
    num: "02",
    title: "L'accompagnement",
    text: "Formation dédiée, back-office complet, outils et méthode, et accès direct aux fournisseurs. Tu démarres avec un cadre structuré.",
    img: IMG_D,
    alt: "Un manager Alternativ accompagné par l'équipe nationale",
  },
  {
    num: "03",
    title: "La rémunération",
    text: "Commissions directes élevées sur chaque contrat signé par tes vendeurs. Chaque année, ton équipe retourne chez les clients pour réviser leurs contrats : ton portefeuille travaille pour toi, sans mécanisme de récurrence artificiel.",
    img: null,
    alt: "",
  },
  {
    num: "04",
    title: "Le lancement",
    text: "Un territoire exclusif, un plan de marche éprouvé et une équipe dédiée à ton ouverture — avec Alternativ derrière toi.",
    img: IMG_C,
    alt: "Remise des clés d'une nouvelle agence Alternativ",
  },
];

export default function Manifesto() {
  return (
    <section id="manifeste" data-testid="manifesto-section" className="relative py-28 md:py-36 border-t border-emerald-400/10">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal className="max-w-2xl mb-16 md:mb-20">
          <p className="font-jbmono text-xs uppercase tracking-[0.3em] text-emerald-400 mb-6">03 — Le manifeste</p>
          <h2 className="font-display font-bold tracking-tight leading-tight text-3xl sm:text-4xl lg:text-5xl">
            Quatre chapitres vers
            <span className="text-emerald-400"> ton indépendance.</span>
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-6">
          {chapters.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.08} className={i % 2 === 1 ? "md:mt-14" : ""}>
              <article
                data-testid={`manifesto-chapter-${c.num}`}
                className="group relative h-full rounded-[1.75rem] border border-emerald-400/10 bg-[#0E1713]/70 p-8 md:p-10 transition-all duration-500 hover:border-emerald-400/40 hover:bg-[#0E1713] hover:shadow-[0_30px_80px_-40px_rgba(16,185,129,0.4)]"
              >
                {c.img && (
                  <div className="mb-8 overflow-hidden rounded-2xl border border-emerald-400/15">
                    <img
                      src={c.img}
                      alt={c.alt}
                      data-testid={`manifesto-image-${c.num}`}
                      className="w-full h-auto scale-[1.12] opacity-90 transition-all duration-700 group-hover:opacity-100 group-hover:scale-[1.15]"
                    />
                  </div>
                )}
                <div className="flex items-start justify-between mb-10">
                  <span className="font-jbmono text-5xl md:text-6xl font-bold text-stroke-emerald group-hover:text-emerald-400 group-hover:[-webkit-text-stroke:0px] transition-all duration-500">
                    {c.num}
                  </span>
                  <span className="w-10 h-10 rounded-full border border-emerald-400/20 grid place-items-center text-emerald-400 opacity-0 -rotate-45 group-hover:opacity-100 group-hover:rotate-0 transition-all duration-500">
                    <ArrowUpRight className="w-4 h-4" />
                  </span>
                </div>
                <h3 className="font-display font-bold text-xl sm:text-2xl mb-4">{c.title}</h3>
                <p className="text-slate-400 leading-relaxed text-sm md:text-base">{c.text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
